(function ($) {

    if ($('.single-career').length) {
        $('.wpcf7 .file-trigger').on('click', function() {
            $('.single-career .wpcf7 .custom-file-picker').removeClass('error');
            $(this).closest('.file-input-container').find('input[type="file"]').trigger('click');
        });

        $('.wpcf7 .file-input-container input[type="file"]').on('change', function(e) {
            let resultBlock =  $(this).closest('.file-input-container').find('.custom-file-picker .file-result');
            let resultOutput = resultBlock.find('span.selected-file');
            let noFileOutput = resultBlock.find('span.no-file');

            $('.single-career .wpcf7 .custom-file-picker').removeClass('error');

            if (e.target.files.length) {
                var fileName = e.target.files[0].name;
            }

            if (fileName) {
                resultOutput.text(fileName);
                resultBlock.addClass('active');
                resultOutput.addClass('active');
                noFileOutput.removeClass('active');
            } else {
                resultBlock.removeClass('active');
                resultOutput.removeClass('active');
                noFileOutput.addClass('active');
            }
        });

        $(document).on('wpcf7invalid', function(e) {
            let inputs = e.detail.inputs;

            for (let i = 0; i < inputs.length; i++ ) {
                if ('file-career' === inputs[i].name) {
                    if (!inputs[i].value.size || inputs[i].value.size > 2000000) {
                        console.log('file error');
                        $('.single-career .wpcf7 .custom-file-picker').addClass('error');
                    }
                    break;
                }
            }
        });
    }

})(jQuery);